/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { colors, FormLabel, HFlow, VFlow } from 'bold-ui'
import { Box } from 'components/Box'
import { RadioField, RadioGroupField } from 'components/form'
import { InfoIcon } from 'components/InfoIcon'
import { PeriodoCadastroIndividualEnum } from 'graphql/types.generated'
import { MetaRoot } from 'util/metaPath'

import {
  AcompanhamentoCondicaoSaudeFormModel,
  periodoRegistroTriaRecord,
  resultadosTriaOptions,
} from '../model-acompanhamentoCondicaoSaude'

interface TriaFilterProps {
  meta: MetaRoot<AcompanhamentoCondicaoSaudeFormModel>
}

const INFO_TEXT =
  'São considerados os dados relacionados às respostas da TRIA na Ficha de Cadastro Individual do cidadão.'

export function AcompanhamentoCondicaoSaudeTriaFilterGroup(props: TriaFilterProps) {
  const { meta } = props

  return (
    <VFlow>
      <Box style={styles.box}>
        <VFlow vSpacing={0.5}>
          <HFlow hSpacing={0.5}>
            <FormLabel label='Período do registro' required />
            <InfoIcon text={INFO_TEXT} icon='infoCircleFilled' tooltipStyle={styles.tooltip} />
          </HFlow>
          <HFlow hSpacing={2.25}>
            <RadioField
              name={meta.tria.periodoRegistro.absolutePath()}
              label={periodoRegistroTriaRecord[PeriodoCadastroIndividualEnum.SEIS_MESES]}
              value={PeriodoCadastroIndividualEnum.SEIS_MESES}
            />
            <RadioField
              name={meta.tria.periodoRegistro.absolutePath()}
              label={periodoRegistroTriaRecord[PeriodoCadastroIndividualEnum.DOZE_MESES]}
              value={PeriodoCadastroIndividualEnum.DOZE_MESES}
            />
          </HFlow>
          <VFlow vSpacing={1}>
            <RadioGroupField
              name={meta.tria.resultadosTria.absolutePath()}
              label='Resultados da TRIA'
              options={resultadosTriaOptions}
              lines={2}
              required
            />
          </VFlow>
        </VFlow>
      </Box>
    </VFlow>
  )
}

const styles = {
  box: css`
    border-color: ${colors.turquoise.c40};
    width: max-content;
  `,
  tooltip: css`
    margin-bottom: 0.25rem;
  `,
}
